import React, { useState } from "react";
import HeroBg from "../../assets/home-hero1.webp";
import Button from "../common/Button";
import AIAssistantChatModal from "../common/AIAssistantChatModal";
import { AssistantIcon } from "../Icons";

const Hero = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleViewAllCourses = () => {
    const section = document.getElementById("all-courses-section");

    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="relative mx-auto max-w-[1920px] overflow-hidden">
      <img
        src={HeroBg}
        alt="hero"
        className="h-[220px] w-full object-cover sm:h-[280px] md:h-[360px] lg:h-auto lg:min-h-[420px]"
      />

      <div className="absolute inset-x-0 top-[18%] z-10 px-4 sm:top-[22%] sm:px-8 md:top-[24%] lg:top-[28%] xl:top-[32%] 2xl:top-[369px]">
        <div className="mx-auto w-full max-w-[320px] sm:max-w-[480px] md:max-w-[640px] lg:max-w-[760px] xl:max-w-[900px]">
          <h1 className="text-center text-2xl font-bold leading-7 text-white sm:text-3xl sm:leading-9 md:text-4xl md:leading-10 2xl:text-5xl 2xl:leading-[75px]">
            Explore Our STEAM Courses
          </h1>
          <p className="mt-2 text-center text-sm font-normal leading-5 tracking-[1%] text-white sm:mt-3 sm:text-base sm:leading-6 md:text-[22px] md:leading-7 2xl:mt-0 2xl:text-2xl">
            From Science to Technology, Engineering to Arts, and Mathematics –
            learn skills that power the future
          </p>
          <div className="mt-3 flex justify-center sm:mt-4 md:mt-6 lg:mt-8">
            <Button
              btnClassName="rounded-full bg-[#FF6636] tracking-[1%] text-white font-medium py-1.5 px-4 text-sm leading-6 sm:py-2 sm:px-6 sm:text-lg md:py-2.5 md:text-[22px] lg:py-3 lg:px-9 2xl:py-4 2xl:px-12 2xl:text-2xl 2xl:leading-7"
              btnText="View All Courses"
              onClick={handleViewAllCourses}
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-3 right-3 z-10 sm:bottom-4 sm:right-4 lg:bottom-6 lg:right-10 2xl:bottom-16 2xl:right-[114px]">
        <button
          type="button"
          aria-label="AI Assistant"
          onClick={() => setIsChatOpen(true)}
          className="flex items-center justify-center gap-0 rounded-xl bg-[#FF6636] px-2.5 py-1 text-xs font-medium leading-[14px] text-white transition-colors duration-200 min-[400px]:gap-4 min-[400px]:px-3 min-[400px]:py-1.5 min-[400px]:text-sm min-[400px]:leading-[16.8px] lg:rounded-2xl lg:px-4 lg:py-2.5"
        >
          <AssistantIcon />
          <span className="hidden min-[400px]:inline">AI Assistant</span>
        </button>
      </div>

      <AIAssistantChatModal
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
      />
    </div>
  );
};

export default Hero;
